import React from 'react';
import FileUploadForm from '../../Forms/Rechner/FileUploadForm';

const FileUploadPage: React.FC = () => {
  return (
    <>
      <div className="container">
        <div className="page-content-text">
          <p>
            Hier können die Excel-Dateien hochgeladen werden, die für
            die Auswertungen des Bu-Rechners genutzt werden können.
          </p>
        </div>
        <FileUploadForm></FileUploadForm>
      </div>
    </>
  );
};

export default FileUploadPage;
